<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-body" v-if="seeker&&seekerFile">
      <p>
        <span style="color: red;">{{seeker.name}}</span>様のファイルを削除いたします。<br>
        <span style="color: red;">「削除する」</span>を押下する前に確認をお願い致します。<br>
        ファイル名：<span style="color: red;">{{seekerFile.name}}</span>
      </p>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="deleteSeekerFile(seekerFile)">削除する</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  name: 'ModalDelete',
  componentName: 'ModalDelete',
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    }
  },
  data () {
    return {
      title: 'ファイルの削除',
      seeker: null,
      seekerFile: null
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', {
        flg: false,
        seeker: null,
        seekerFile: null
      })
      this.seeker = null
      this.seekerFile = null
    },
    deleteSeekerFile (data) {
      this.$emit('deleteSeekerFile', data.pk)
      this.seeker = null
      this.seekerFile = null
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  p {
    text-align: left;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ModalDelete.vue